import { render, staticRenderFns } from "./RedirectFormActions.vue?vue&type=template&id=3d05af62&scoped=true&"
import script from "./RedirectFormActions.vue?vue&type=script&lang=js&"
export * from "./RedirectFormActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d05af62",
  null
  
)

export default component.exports